import React from "react";

import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

const Footer: React.FC = () => (
  <Jumbotron
    flexDirection="column"
    justifyContent="center"
    textAlign="center"
    minHeight="100vh"
  >
    <Jumbotron
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
      height="90vh"
    >
      <Text text="Crafted by Rajan ❤️" fs="30px" padding="20px" />
    </Jumbotron>
    <Jumbotron
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      height="40px"
    >       
      <Text width="50%" text="+91-8872921112" fs="14px" padding="20px" />
      <Text width="50%" text="rajanlagah@gmail.com" fs="14px" padding="20px" />
    </Jumbotron>
    <Jumbotron
      flexDirection="row"
      justifyContent="center"
      textAlign="center"
      padding="5px"
    >  
    <img width="20px" alt="github" src="./tools/github.svg" onClick={()=>window.open("https://github.com/rajanlagah")}/>
  </Jumbotron>
  </Jumbotron>
);

export default Footer;
